import { useRef, useState } from 'react'

interface Props {
  id: string
  label: string
  value: string
  help?: string
}

/** Read-only URL with a copy button, for pasting into the booking system. */
export default function CopyField({ id, label, value, help }: Props) {
  const [copied, setCopied] = useState(false)
  const input = useRef<HTMLInputElement>(null)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard blocked (no permission, no https): select the text so Ctrl+C still works.
      input.current?.select()
    }
  }

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div style={{ display: 'flex', gap: '0.4rem' }}>
        <input id={id} ref={input} type="text" readOnly value={value} style={{ flex: 1 }} />
        <button type="button" className="btn" onClick={() => void copy()}>
          {copied ? 'Gekopieerd' : 'Kopiëren'}
        </button>
      </div>
      {help && <span className="help">{help}</span>}
    </div>
  )
}
